import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useDebouncedCallback, } from '@tanstack/react-pacer';
import { tableFeatures, useTable, } from '@tanstack/react-table';
import { useMemo, } from 'react';
import { prop, } from 'remeda';
import { api, } from '../../../api/Api.js';
import { Button, } from '../../../components/Button.js';
import { Textbox, } from '../../../components/Textbox.js';
const features = tableFeatures({});
const createColumns = (refresh) => [
    {
        accessorFn: prop('displayName'),
        header: 'Display Name',
    },
    {
        accessorFn: prop('phone'),
        header: 'Nummer',
    },
    {
        accessorFn: prop('country'),
        header: 'Land',
    },
    {
        accessorFn: prop('postalCode'),
        header: 'PLZ',
    },
    {
        accessorFn: prop('city'),
        header: 'Stadt',
    },
    {
        accessorFn: prop('street'),
        header: 'Straße',
    },
    {
        id: 'actions',
        cell: ({ row }) => (_jsx(Button, { position: "external", className: "text-center", size: "sm", onClick: async () => {
                const response = await api.therapist.imported.remove.request({
                    id: [row.original.id],
                });
                if (response.status === 'ok') {
                    await refresh();
                }
            }, children: "L\u00F6schen" })),
    },
];
export function ImportedTherapistSearch(props) {
    const columns = useMemo(() => createColumns(props.refresh), [props.refresh]);
    const table = useTable({
        key: ImportedTherapistSearch.name,
        features,
        columns,
        data: props.response.list,
    });
    const setSearchDebounced = useDebouncedCallback((displayName) => {
        props.setSearch(displayName === ''
            ? {}
            : { displayName });
    }, {
        wait: 300,
    });
    return (_jsxs("div", { children: [_jsx(Textbox, { label: "Display Name", defaultValue: props.search.displayName ?? '', onChange: e => {
                    setSearchDebounced(e.currentTarget.value);
                }, autoFocus: true, position: "external", type: "text" }), _jsxs("table", { children: [_jsx("thead", { children: table.getHeaderGroups().map(headerGroup => (_jsx("tr", { children: headerGroup.headers.map(header => (_jsx("th", { children: header.isPlaceholder ? null : _jsx(table.FlexRender, { header: header }) }, header.id))) }, headerGroup.id))) }), _jsx("tbody", { children: table.getRowModel().rows.map(row => (_jsx("tr", { children: row.getAllCells().map(cell => (_jsx("td", { className: "p-1", children: _jsx(table.FlexRender, { cell: cell }) }, cell.id))) }, row.id))) })] })] }));
}
//# sourceMappingURL=ImportedTherapistSearch.js.map